// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer_container__MXUvq","box":"Footer_box__2kkyv","footerTitulo":"Footer_footerTitulo__37dQ9"};